import { EvtStatsCard } from "components/stats/display-card";
import { EvtStatsCardPlaceholder } from "components/stats/placeholder";
import QueryError from "components/query-error";
import React from "react";
import { formatHoursToTime } from "components/timesheet/utils";
import { useMilestoneLoggedHours } from "components/milestone/stats/logged/useMilestoneLoggedHours";

export const MilestoneTotalLoggedHoursStat = ({ id, dateRange }) => {
  const { data, isLoading, isError, refetch, error } = useMilestoneLoggedHours(
    id,
    dateRange
  );

  if (isLoading) {
    return <EvtStatsCardPlaceholder />;
  }

  if (isError) {
    return (
      <QueryError message="Failed to load Logged hours." onRetry={refetch} />
    );
  }

  return <EvtStatsCard label="Logged" value={formatHoursToTime(data)} />;
};
